import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row c-item-name" }
const _hoisted_2 = {
  key: 0,
  class: "go-left mr12"
}
const _hoisted_3 = ["innerHTML", "title"]
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_img = _resolveComponent("c-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item?.[_ctx.src])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_c_img, {
            class: "w45 h45 radius10",
            src: _ctx.getFullImage(_ctx.item?.[_ctx.src])
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "c-item-name-top",
        innerHTML: _ctx.item?.[_ctx.top] || 'N/A',
        title: _ctx.item?.[_ctx.top] || 'N/A'
      }, null, 8, _hoisted_3),
      (_ctx.isBottom)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.item?.[_ctx.bottom] || "N/A"), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}